export function newHomepageObject() {
  this.banner_image = null,
    this.danube_videolink = null,
    this.danube_title = null,
    this.danube_description = null,
    this.aboutus_title = null,
    this.aboutus_description = null,
    this.card1_title = null,
    this.card1_description = null,
    this.card2_title = null,
    this.card2_description = null,
    this.card3_img = null,
    this.card4_img = null,
    this.slider_galary = []
  this.slider_URL = []
}